/**
 * SECTION 4A JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise SECTION 4A UI, data
         * UI interaction functions
         */
        console.log( 'SECTION 4A - init' );
        
        this.aon_section_4a_data = [];
        
        this.product_value_entry_count = 0;

        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
			console.log( '4A Data Load live - Business Plan...' );
			if ( $( '#section_4a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
				console.log( '4A - Trying to load data - Business Plan...' );
				this.loadData( 'load_live' );
				
				// Render Data...
        		this.renderData();
			}
            
        } else { // If not Business Plan page then we are in 4A...
			console.log( '4A Data Load live - 4A...' );
            if ( $( '#section_4a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
				
				// Render Data...
        		this.renderData();
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
				
				// Render Data...
        		this.renderData();
				
            }
            //this.loadData( 'load_demo' );
        }
        
        
        // Render Data...
        //this.renderData();
        
        // Get total of fields on 's4_a_annual_overheads_form'...
        $( 'body' ).on( 'keyup', '#s4_a_annual_overheads_form input', function( event ) {
            var total = 0;
            $( '#s4_a_annual_overheads_form input' ).each(function( index ) {
                // We need to keep the two 'annual_overheads' forms in sync,
                // we get the id of each field and copy the value being entered
                var id = $( this ).attr( 'id' );
                console.log( 'ID: #' + id + '' );
                $( '#' + id + '_single' ).val( $( this ).val() );
                //total = total + parseInt( $( this ).val() * 1, 10 );
                total = total + $( this ).val() * 1;
            });
            
            localUpdateBusinessOverheadsFields( total );
            
            console.log( 'checking s4_a_annual_overheads_form... - total: ' + total );
            event.preventDefault();
        });
        
        // Get total of fields on 's4_a_annual_overheads_form_single'...
        $( 'body' ).on( 'keyup', '#s4_a_annual_overheads_form_single input', function( event ) {
            var total = 0;
            $( '#s4_a_annual_overheads_form_single input' ).each(function( index ) {
                // We need to keep the two 'annual_overheads' forms in sync,
                // we get the id of each field and copy the value being entered
                var id = $( this ).attr( 'id' );
                console.log( 'ID: #' + id );
                id = id.replace( '_single', '' );
                console.log( id.replace( '_single', '' ) );
                console.log( 'Replaced ID: #' + id );
                $( '#' + id + '' ).val( $( this ).val() );
                //total = total + parseInt( $( this ).val() * 1, 10 );
                total = total + $( this ).val() * 1;
            });
            
            localUpdateBusinessOverheadsFields( total );
            
            console.log( 'checking s4_a_annual_overheads_form_single... - total: ' + total );
            event.preventDefault();
        });
        
        var localUpdateBusinessOverheadsFields = ( total ) => {
            this.updateBusinessOverheadsFields( total );
        }
        
        // Get total of fields on 's4_a_personal_salary_form'...
        $( 'body' ).on( 'keyup', '#s4_a_personal_salary_form input', function( event ) {
            localUpdateSalaryFields();
            
            console.log( 'checking s4_a_personal_salary_form...' );
            event.preventDefault();
        });
        
        var localUpdateSalaryFields = () => {
            this.updateSalaryFields();
        }
  
        
        
        // Calculating Cost Price...
        $( 'body' ).on( 'keyup', '#s4_a_cost_price_form_time_to_make, #s4_a_cost_price_form_materials_production', function( event ) {
            var daily_costs = parseFloat( $( '.daily_overhead_rate' ).text() );
            if ( $( '#s4_a_cost_price_form_time_to_make' ).val() == '' ) {
                var time = 0;
            } else {
                var time = parseFloat( $( '#s4_a_cost_price_form_time_to_make' ).val() );
            }
            if ( $( '#s4_a_cost_price_form_materials_production' ).val() == '' ) {
                var materials = 0;
            } else {
                var materials = parseFloat( $( '#s4_a_cost_price_form_materials_production' ).val() );
            }
            var time_materials =  time * daily_costs;
            var total =  parseFloat( time_materials ) + parseFloat( materials );
            $( '.cost_of_product_or_service' ).text( parseFloat( total ).toFixed( 2 ) );
            
            // !! NEED TO ADD SAVING CODE HERE, AND ALSO ADD FIELD(S) TO DATA ARRAY !!
            
            console.log( 'Updating s4_a_cost_price_form...: ' );
            event.preventDefault();
        });
        
        // Calculating Selling Price...
        $( 'body' ).on( 'keyup', '#s4_a_selling_price_form_profit_margin', function( event ) {
            if ( $( '#s4_a_selling_price_form_profit_margin' ).val() == '' ) {
                var percentage = 0;
            } else {
                var percentage = parseFloat( $( '#s4_a_selling_price_form_profit_margin' ).val() );
            }
            var cost = parseFloat( $( '.cost_of_product_or_service' ).text() );
            var margin = ( percentage / 100 ) * cost;
            var total =  parseFloat( margin ) + parseFloat( cost );
            $( '.selling_price_of_product_service' ).text( parseFloat( total ).toFixed( 2 ) );
            
            console.log( 'percentage: ' + percentage );
            console.log( 'cost - pre: ' + $( '.cost_of_product_or_service' ).text() );
            console.log( 'cost: ' + cost );
            console.log( 'margin: ' + margin );
            console.log( 'total: ' + total );
            
            console.log( 'Updating s4_a_selling_price_form...: ' );
            event.preventDefault();
        });
        
        // Calculating Retail Price...
        $( 'body' ).on( 'keyup', '#s4_a_retail_price_form_customers_profit_margin', function( event ) {
            if ( $( '#s4_a_retail_price_form_customers_profit_margin' ).val() == '' ) {
                var percentage = 0;
            } else {
                var percentage = parseFloat( $( '#s4_a_retail_price_form_customers_profit_margin' ).val() );
            }
            var selling_price = parseFloat( $( '.selling_price_of_product_service' ).text() );
            var margin = ( percentage / 100 ) * selling_price;
            var total =  parseFloat( margin ) + parseFloat( selling_price );
            $( '.retail_price_of_product_service' ).text( parseFloat( total ).toFixed( 2 ) );
            
            console.log( 'percentage: ' + percentage );
            console.log( 'selling_price - pre: ' + $( '.retail_price_of_product_service' ).text() );
            console.log( 'selling_price: ' + selling_price );
            console.log( 'margin: ' + margin );
            console.log( 'total: ' + total );
            
            console.log( 'Updating s4_a_retail_price_form...: ' );
            event.preventDefault();
        });
        
        
        
        // Click on Next button 'annual_monthly_overheads_next' page...
        $( 'body' ).on( 'click', '.annual_monthly_overheads_next', ( event ) => {
            this.saveOverheads();
            event.preventDefault();
        });
        
        // Click on Next button 'personal_salary_next' page...
        $( 'body' ).on( 'click', '.personal_salary_next', ( event ) => {
            this.saveSalary();
            event.preventDefault();
        });
        
        // Click on Next button 'cost_price_next' page...
        $( 'body' ).on( 'click', '.cost_price_next', ( event ) => {
            this.saveCostPrice();
            event.preventDefault();
        });
        
        // Click on Next button 'selling_price_next' page...
        $( 'body' ).on( 'click', '.selling_price_next', ( event ) => {
            this.saveSellingPrice();
            event.preventDefault();
        });
        
        // Click on Next button 'retail_price_next' page...
        $( 'body' ).on( 'click', '.retail_price_next', ( event ) => {
            this.saveRetailPrice();
            event.preventDefault();
        });
        
        
        
        
        /*
         * Add / Edit Modal interaction...
         */
        
        var s4_a_product_value_add_edit_modal_mode = ''; // Sets 'Add 'or 'Edit' mode in the modal...
        var s4_a_product_value_volume_mode = 'value'; // Set to either 'value' or 'volume', determines what value the slider in the modal adjusts...
        
        // Click to Edit existing Product Value entry modal link...
        $( 'body' ).on( 'click', '.edit_product_value_entry', function( event ) {
            
            if ( !$( '#business_plan' ).length > 0 ) {
                s4_a_product_value_add_edit_modal_mode = 'edit';

				$( this ).find( $( '.slider-edit-tooltip' ) ).remove();
                var name = $( this ).text();
                var id = $( this ).attr( 'data-product-value-entry-id' );
                //var product_value = $( this ).attr( 'data-product-value' );
                //var product_volume = $( this ).attr( 'data-product-volume' );
                var product_value = $( '#product_price_point_slider_' + id + '_input' ).val();
                var product_volume = $( '#product_volume_slider_' + id + '_input' ).val();
                console.log( 'product_value: ' + product_value );
                console.log( 'product_volume: ' + product_volume );
                /*if ( $( this ).parent().attr( 'id' ) == 'product_price_point_slider' ) { // Value slider mode
                    s4_a_product_value_volume_mode = 'value';
                    $( '#product_price_point_slider_src_input' ).val( product_value ).change();

                } else if ( $( this ).parent().attr( 'id' ) == 'product_volume_slider' ) { // Volume slider mode
                    s4_a_product_value_volume_mode = 'volume';
                    $( '#product_price_point_slider_src_input' ).val( product_volume ).change();
                }*/

                $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_name' ).val( name );
                $( '#s4_a_product_value_add_modal #add_edit_product_value_entry_id' ).val( id );
                $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_value' ).val( product_value );
                $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_volume' ).val( product_volume );

                console.log( 'Start opening Product Value Modal - Edit mode...');
                openProductValueModal();
                console.log( 'Done opening Product Value Modal - Edit mode...');
            }
            event.preventDefault();
        });
        
        // Click on Add Product Value entry modal link...
        $( 'body' ).on( 'click', '.add_product_value_entry', function( event ) {
            s4_a_product_value_add_edit_modal_mode = 'add';
            s4_a_product_value_volume_mode = 'value'; // We only ever Add in Product Value mode so we can just set this here
            var name = '';
            var id = getProductValueEntryCount();
            var product_value = 50;
            var product_volume = 50;
            $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_name' ).val( name );
            $( '#s4_a_product_value_add_modal #add_edit_product_value_entry_id' ).val( id );
            $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_value' ).val( product_value );
            $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_volume' ).val( product_volume );
            
            //$( '#product_price_point_slider_src_input' ).val( 50 ).change();            
            
            console.log( 'Start opening Product Value Modal - Add mode...');
            openProductValueModal();
            console.log( 'Done opening Product Value Modal - Add mode...');
            
            event.preventDefault();
        });
        
        var getProductValueEntryCount = () => {
            if ( this.aon_section_4a_data[ 0 ][ 's4_a_product_1' ] == '' ) {
                return 1;
            } else if ( this.aon_section_4a_data[ 0 ][ 's4_a_product_2' ] == '' ) {
                return 2;
            } else if ( this.aon_section_4a_data[ 0 ][ 's4_a_product_3' ] == '' ) {
                return 3;
            } else if ( this.aon_section_4a_data[ 0 ][ 's4_a_product_4' ] == '' ) {
                return 4;
            } else if ( this.aon_section_4a_data[ 0 ][ 's4_a_product_5' ] == '' ) {
                return 5;
            } else {
                return null;
            }
            //return this.product_value_entry_count + 1;
        }
        
        var openProductValueModal = () => {
            // Open specific modal depending on whether we're adding / editing entries
            console.log( 'Called opening Product Value Modal...');
            $( '#s4_a_product_value_add_modal' ).foundation( 'open' );
        }        

        // 'Save' button click within Product Value entry modal...
        $( 'body' ).on( 'click', '#save_add_edit_product_value_entry', function( event ) {
            // Save data to existing
            var id = aon_craft_utils.removeHTMLTags( $( '#s4_a_product_value_add_modal #add_edit_product_value_entry_id' ).val() );
            var name = aon_craft_utils.removeHTMLTags( $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_name' ).val() );
            var product_value = aon_craft_utils.removeHTMLTags( $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_value' ).val() );
            var product_volume = aon_craft_utils.removeHTMLTags( $( '#s4_a_product_value_add_modal #s4_a_product_value_form_product_volume' ).val() );
            //var product_value = 50;
            //var product_volume = 50;
            if ( s4_a_product_value_add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && name != '' ) {
                    saveProductValueVolumeEntry( id, name, product_value, product_volume );
                }
            } else if ( s4_a_product_value_add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( id != '' && name != '' ) {
                    saveProductValueVolumeEntry( id, name, product_value, product_volume );
                }
            } else if ( s4_a_product_value_add_edit_modal_mode == 'delete' ) {
                // Delete...
                deleteProductValueVolumeEntry( id );
            }
            
            event.preventDefault();
        });
        
        
        var saveProductValueVolumeEntry = ( id, name, product_value, product_volume ) => {
            var entry = name + ',' + product_value + ',' + product_volume;
            this.aon_section_4a_data[ 0 ][ 's4_a_product_' + id ] = entry;
            console.log( 's4_a_product_' + id + ': s4_a_product_' + id );
            console.log( 'Saved: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_' + id ] );
            this.renderData();
            $( '#s4_a_product_value_add_modal' ).foundation( 'close' );
        }
        
        var deleteProductValueVolumeEntry = ( id ) => {
            this.aon_section_4a_data[ 0 ][ 's4_a_product_' + id ] = '';
            this.renderData();
            $( '#s4_a_product_value_add_modal' ).foundation( 'close' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_add_edit_product_value_entry ').text( save_text ); // Save
            $( '#save_add_edit_product_value_entry ').removeClass( 'delete' );            
        }

        
        /*
         * MODAL Delete / Normal button states
         */
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_text' ).val();
				var delete_text = $( '.modal_delete_text' ).val()
                $( '#save_add_edit_product_value_entry ').text( delete_text ); // DELETE
                $( '#save_add_edit_product_value_entry ').addClass( 'delete' );
                s4_a_product_value_add_edit_modal_mode = 'delete';
                console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_add_edit_product_value_entry ').text( save_text ); // Save
                $( '#save_add_edit_product_value_entry ').removeClass( 'delete' );
                s4_a_product_value_add_edit_modal_mode = 'edit';
                console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#s4_a_product_value_add_modal', function() {
            if ( s4_a_product_value_add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_add_edit_product_value_entry ').text( save_text ); // Save
                $( '#save_add_edit_product_value_entry ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
                
            } else if ( s4_a_product_value_add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                
            }
			$( '.sliders .slider_wrapper h4 a' ).find( $( '.slider-edit-tooltip' ) ).remove();
            $( '#s4_a_product_value_form_product_name' ).focus();
            //$( '#product_price_point_slider_src' ).foundation( '_reflow' );
            console.log( 'products_add_edit_entry_modal open' );
        });
        

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#s4_a_product_value_add_modal', function() {
            $( '#s4_a_product_value_form_product_name' ).val( '' );
            $( '#s4_a_product_value_form_price_point' ).val( '' );
            $( '#s4_a_product_value_form_product_value' ).val( '' );
            $( '#s4_a_product_value_form_product_volume' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_products_entry ').text( save_text ); // Save
            $( '#save_products_entry ').removeClass( 'delete' );
            //$( '#product_price_point_slider_src_input' ).val( 50 ).change(); 
            console.log( 'products_add_edit_entry_modal close - ' + $( '#s4_a_product_value_form_product_value' ).val() );
        });
        
        // Fires multiple times as slider is moved...
        $('.price_point_slider .slider').on( 'moved.zf.slider', function( e, handle ) {
            var id = $( this ).attr( 'id' );
//            var slider_val = $( '#product_price_point_slider_src_input' ).val();
//            if ( s4_a_product_value_volume_mode == 'value' ) {
//                $( '#s4_a_product_value_form_product_value' ).val( slider_val );
//                
//            } else if ( s4_a_product_value_volume_mode == 'volume' ) {
//                $( '#s4_a_product_value_form_product_volume' ).val( slider_val );
//            }
            
            console.log ( id + ' moved' );
        });
        
        // Fires after slider has finished moving...
        $('.price_point_slider .slider').on( 'changed.zf.slider', function( e, handle ) {
            var long_id = $( this ).attr( 'id' );
            var id = $( this ).attr( 'data-product-entry-id' );
            var name = $( '#product_price_point_slider_' + id + '_title a' ).text();
            var product_value = $( '#product_price_point_slider_' + id + '_input' ).val();
            var product_volume = $( '#product_volume_slider_' + id + '_input' ).val();
            
            //saveProductValueVolumeEntry( id, name, product_value, product_volume );
            console.log( 'Parent ID: ' + $( this ).parent( '.slider_wrapper' ).attr( 'id' ) );
            var parent = $( this ).parent( '.slider_wrapper' ).attr( 'id' );
            //if ( $( this ).parent( '.slider_wrapper' ).is( ':visible' ) ) {
            if ( $( '#' + parent ).is( ':visible' ) ) {
                console.log( long_id +' is visible');
                saveProductValueVolumeEntry( id, name, product_value, product_volume );
            } else {
                console.log( long_id + ' is hidden');
            }
            console.log ( long_id + ' : long_id - changed' );
            console.log ( id + ' : id - changed' );
            console.log ( name + ' : name - changed' );
            console.log ( product_value + ' : product_value - changed' );
            console.log ( product_volume + ' : product_volume - changed' );
        });
        
        // Click on 'product_value_start_next' next link...
        $( 'body' ).on( 'click', '.product_value_start_next', function( event ) {
            event.preventDefault();
        });
        
        // Click on 'product_volume_start_next' next link...
        $( 'body' ).on( 'click', '.product_volume_start_next', function( event ) {
            event.preventDefault();
        });
        
            
                
        
        /*// Click on 'product_price_point_slider_next' next link...
        $( 'body' ).on( 'click', '.product_price_point_slider_next', function( event ) {
            //$( '.product_price_point_slider_step_a .price_point_slider').appendTo( '.product_price_point_slider_step_b' );
            event.preventDefault();
        });
        
        // Click on 'product_price_point_slider_back' back link...
        $( 'body' ).on( 'click', '.product_price_point_slider_back', function( event ) {
            //$( '.product_price_point_slider_step_b .price_point_slider').appendTo( '.product_price_point_slider_step_a' );
            event.preventDefault();
        });
        
        // Click on 'product_volume_slider_a_next' next link...
        $( 'body' ).on( 'click', '.product_volume_slider_a_next', function( event ) {
            //$( '.product_volume_slider_step_a .price_point_slider').appendTo( '.product_volume_slider_step_b' );
            event.preventDefault();
        });
        
        // Click on 'product_volume_slider_b_back' back link...
        $( 'body' ).on( 'click', '.product_volume_slider_b_back', function( event ) {
            //$( '.product_volume_slider_step_b .price_point_slider').appendTo( '.product_volume_slider_step_a' );
            event.preventDefault();
        });*/
        
        // Click on 'questions_to_think_about_next' next link...
        /*$( 'body' ).on( 'click', '.questions_to_think_about_next', function( event ) {
            console.log( 'Last step, probably saving data via AJAX here...' );
            event.preventDefault();
        });*/

		
		// Slider element hover to show `Edit?` tooltip...
        $( 'body' ).on( 'mouseenter', '.sliders .slider_wrapper h4 a', function() {
			$( this ).find( $( '.slider-edit-tooltip' ) ).remove();
			var edit_tooltip = $( '.slider-edit-tooltip.hide' ).clone();
			edit_tooltip.removeClass( 'hide' );
			$( this ).append( edit_tooltip );
			/*var tooltip_wrapper = $( this );
			var tooltip_remove = function() {
				tooltip_wrapper.find( $( '.slider-edit-tooltip' ) ).remove();
				console.log( 'Tooltip removed' );
			};
			console.log( 'Removing tooltip' );
			setTimeout(tooltip_remove, 2000);*/
			
        });

        $( 'body' ).on( 'mouseleave', '.sliders .slider_wrapper h4 a', function() {
			$( this ).find( $( '.slider-edit-tooltip' ) ).remove();
        });
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        

    },
    
    updateSalaryFields() {
        var total = 0;
        $( '#s4_a_personal_salary_form input' ).each(function( index ) {
            //total = total + parseInt( $( this ).val() * 1, 10 );
            total = total + $( this ).val() * 1;
            //console.log( 'total: - ' + total );
            
            if ( total > 0 ) {
                $( '.personal_salary_next' ).removeClass( 'disabled' );
            } else {
                $( '.personal_salary_next' ).addClass( 'disabled' );
            }
        });
        
        //console.log( "total - " + total );
        //console.log( "$( '#s4_a_annual_overheads_form_total' ).text() - " + $( '#s4_a_annual_overheads_form_total' ).text() );
        $( '#s4_a_personal_salary_form_total' ).text( parseFloat( total ).toFixed( 2 ) );
        $( '.annual_salary_total' ).text( parseFloat( total ).toFixed( 2 ) );
        //var annual_business_overheads_costs_total = total + parseInt( $( '#s4_a_annual_overheads_form_total' ).text(), 10 );
        var annual_business_overheads_costs_total = ( parseFloat( total ) + parseFloat( $( '#s4_a_annual_overheads_form_total' ).text() ) ).toFixed( 2 );
        $( '.annual_business_overheads_costs_total' ).text( annual_business_overheads_costs_total );
        $( '.monthly_costs_total' ).text( ( parseFloat( annual_business_overheads_costs_total ) / 12 ).toFixed( 2 ) );
        $( '.weekly_costs_total' ).text( ( parseFloat( annual_business_overheads_costs_total ) / 52 ).toFixed( 2 ) );
        $( '.daily_costs_total, .daily_overhead_rate' ).text( ( parseFloat( annual_business_overheads_costs_total ) / 260 ).toFixed( 2 ) );
    },
    
    updateBusinessOverheadsFields( total ) {
        console.log( "total - " + total );
        console.log( 'updateBusinessOverheadsFields' );
        $( '#s4_a_monthly_overheads_form_rent_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_rent_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_property_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_property_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_phone_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_phone_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_bank_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_bank_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_car_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_car_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_accountancy_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_accountancy_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_wages_etc' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_wages_etc' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_other' ).val( ( parseFloat( $( '#s4_a_annual_overheads_form_other' ).val() ) / 12 ).toFixed( 2 ) );
        $( '#s4_a_monthly_overheads_form_total' ).text( ( parseFloat( $( '#s4_a_annual_overheads_form_total' ).text() ) / 12 ).toFixed( 2 ) );

		console.log( '----------------------' );
		console.log( 's4_a_annual_overheads_form_total: ' + $( '#s4_a_annual_overheads_form_total' ).text() );
		console.log( 's4_a_annual_overheads_form_total - parseFloat: ' + parseFloat( $( '#s4_a_annual_overheads_form_total' ).text() ) );
		console.log( 's4_a_annual_overheads_form_total - parseFloat / 12: ' + ( parseFloat( $( '#s4_a_annual_overheads_form_total' ).text() ) / 12 ) );
		console.log( 's4_a_annual_overheads_form_total - parseFloat / 12 toFixed( 2 ): ' + ( parseFloat( $( '#s4_a_annual_overheads_form_total' ).text() ) / 12 ).toFixed( 2 ) );
		console.log( '----------------------' );
		
        $( '#s4_a_annual_overheads_form_total_single' ).text( parseFloat( total ).toFixed( 2 ) );
        $( '#s4_a_annual_overheads_form_total' ).text( parseFloat( total ).toFixed( 2 ) );
        $( '.annual_business_overheads_total' ).text( parseFloat( total ).toFixed( 2 ) );
        
        if ( total > 0 ) {
            $( '.annual_overheads_a_next' ).removeClass( 'disabled' );
            $( '.annual_monthly_overheads_next' ).removeClass( 'disabled' );
        } else {
            $( '.annual_overheads_a_next' ).addClass( 'disabled' );
            $( '.annual_monthly_overheads_next' ).addClass( 'disabled' );
        }
    },
    
    renderData() {
        console.log( 'renderData - Section 4A');
        
        function calculatePosition( value, sliderid ) {
            /*var pos = 100 - parseInt( value, 10 );
            console.log( 'pos: ' + pos );
            if ( pos > 80 ) {
                var newpos = pos - 7;
                console.log( '> newpos: ' + newpos );
            } else if ( pos < 20 ) {
                var newpos = pos + 7;
                console.log( '< newpos: ' + newpos );
            } else {
                var newpos = pos;
            }*/
            // Get width of slider...
            //var swidth = $( '#product_price_point_slider_' + sliderid ).width(); // E.G. 300px
            // Calculate percentage that 16 pixels (half-width of thumbtrack)            
            //var offset = swidth / value * 100;
            /*console.log( 'value: ' + value );

            var swidth = parseInt( $( '#product_price_point_slider_' + sliderid ).width() ); 
            console.log( 'swidth: ' + swidth );

            var svalue = parseInt( value );
            console.log( 'svalue: ' + svalue );
            
            var offset = 0;
            if ( isNaN( swidth ) || isNaN( 16 ) ) {
                offset = 0;
            } else {
                //offset = ( ( 16/swidth ) * 100 ).toFixed( 3 );
                offset = ( ( 16/swidth ) * 100 );
            }
            console.log( 'offset: ' + offset );
            
            var newpos = value - offset;
            if ( newpos < 0 ) {
                newpos = 0;
            } else if ( newpos > 100 ) {
                newpos = 100;
            }
            console.log( 'newpos: ' + newpos );*/
            
            var newpos = 'calc('+value+'% - 16px)';
            
            if ( value < 5 ) {
                newpos = 'calc('+value+'% - 0)';
            } else if ( value > 93.25 ) {
                newpos = 'calc('+value+'% - 32px)';
            }
            
            return newpos;
        }
        
        // Loop over entries array...
        var entry_count = 1;
        var annual_overheads_form_total = 0;
        var personal_salary_form_total = 0;
        var pvv_count = 0;
        $.each( this.aon_section_4a_data, function( index ) {
            // Loop over data entries...   
            $( '#s4_a_monthly_overheads_form_rent_etc' ).val( this.s4_a_monthly_overheads_form_rent_etc );
            $( '#s4_a_monthly_overheads_form_property_etc' ).val( this.s4_a_monthly_overheads_form_property_etc );
            $( '#s4_a_monthly_overheads_form_phone_etc' ).val( this.s4_a_monthly_overheads_form_phone_etc );
            $( '#s4_a_monthly_overheads_form_bank_etc' ).val( this.s4_a_monthly_overheads_form_bank_etc );
            $( '#s4_a_monthly_overheads_form_car_etc' ).val( this.s4_a_monthly_overheads_form_car_etc );
            $( '#s4_a_monthly_overheads_form_accountancy_etc' ).val( this.s4_a_monthly_overheads_form_accountancy_etc );
            $( '#s4_a_monthly_overheads_form_wages_etc' ).val( this.s4_a_monthly_overheads_form_wages_etc );
            $( '#s4_a_monthly_overheads_form_other' ).val( this.s4_a_monthly_overheads_form_other );
            $( '#s4_a_monthly_overheads_form_total' ).text( this.s4_a_monthly_overheads_form_total );

            $( '#s4_a_annual_overheads_form_rent_etc' ).val( this.s4_a_annual_overheads_form_rent_etc );
            $( '#s4_a_annual_overheads_form_property_etc' ).val( this.s4_a_annual_overheads_form_property_etc );
            $( '#s4_a_annual_overheads_form_phone_etc' ).val( this.s4_a_annual_overheads_form_phone_etc );
            $( '#s4_a_annual_overheads_form_bank_etc' ).val( this.s4_a_annual_overheads_form_bank_etc );
            $( '#s4_a_annual_overheads_form_car_etc' ).val( this.s4_a_annual_overheads_form_car_etc );
            $( '#s4_a_annual_overheads_form_accountancy_etc' ).val( this.s4_a_annual_overheads_form_accountancy_etc );
            $( '#s4_a_annual_overheads_form_wages_etc' ).val( this.s4_a_annual_overheads_form_wages_etc );
            $( '#s4_a_annual_overheads_form_other' ).val( this.s4_a_annual_overheads_form_other );
            $( '#s4_a_annual_overheads_form_total' ).text( this.s4_a_annual_overheads_form_total );

            $( '#s4_a_annual_overheads_form_rent_etc_single').val( this.s4_a_annual_overheads_form_rent_etc );
            $( '#s4_a_annual_overheads_form_property_etc_single').val( this.s4_a_annual_overheads_form_property_etc );
            $( '#s4_a_annual_overheads_form_phone_etc_single').val( this.s4_a_annual_overheads_form_phone_etc );
            $( '#s4_a_annual_overheads_form_bank_etc_single').val( this.s4_a_annual_overheads_form_bank_etc );
            $( '#s4_a_annual_overheads_form_car_etc_single').val( this.s4_a_annual_overheads_form_car_etc );
            $( '#s4_a_annual_overheads_form_accountancy_etc_single').val( this.s4_a_annual_overheads_form_accountancy_etc );
            $( '#s4_a_annual_overheads_form_wages_etc_single').val( this.s4_a_annual_overheads_form_wages_etc );
            $( '#s4_a_annual_overheads_form_other_single').val( this.s4_a_annual_overheads_form_other );
            $( '#s4_a_annual_overheads_form_total_single').text( this.s4_a_annual_overheads_form_total );

            $( '#s4_a_personal_salary_form_rent_etc' ).val( this.s4_a_personal_salary_form_rent_etc );
            $( '#s4_a_personal_salary_form_council_tax_etc' ).val( this.s4_a_personal_salary_form_council_tax_etc );
            $( '#s4_a_personal_salary_form_telephone_internet' ).val( this.s4_a_personal_salary_form_telephone_internet );
            $( '#s4_a_personal_salary_form_debts_etc' ).val( this.s4_a_personal_salary_form_debts_etc );
            $( '#s4_a_personal_salary_form_food_etc' ).val( this.s4_a_personal_salary_form_food_etc );
            $( '#s4_a_personal_salary_form_events_etc' ).val( this.s4_a_personal_salary_form_events_etc );
            $( '#s4_a_personal_salary_form_insurance_etc' ).val( this.s4_a_personal_salary_form_insurance_etc );
            $( '#s4_a_personal_salary_form_tax_etc' ).val( this.s4_a_personal_salary_form_tax_etc );
            $( '#s4_a_personal_salary_form_national_insurance' ).val( this.s4_a_personal_salary_form_national_insurance );
            $( '#s4_a_personal_salary_form_total' ).text( this.s4_a_personal_salary_form_total );
            
            $( '.monthly_costs_total' ).text( this.s4_a_monthly_costs_total );
            $( '.weekly_costs_total' ).text( this.s4_a_weekly_costs_total );
            $( '.daily_costs_total' ).text( this.s4_a_daily_costs_total );
            // Cost Price:
            $( '#s4_a_cost_price_form_time_to_make' ).val( this.s4_a_cost_price_form_time_to_make );
            $( '#s4_a_cost_price_form_materials_production' ).val( this.s4_a_cost_price_form_materials_production );
            $( '.cost_of_product_or_service' ).text( this.s4_a_cost_of_product_or_service );
            // Selling Price:
            $( '#s4_a_selling_price_form_profit_margin' ).val( this.s4_a_selling_price_form_profit_margin );
            $( '.selling_price_of_product_service' ).text( this.s4_a_selling_price_of_product_service );
            // Retail Price:
            $( '#s4_a_retail_price_form_customers_profit_margin' ).val( this.s4_a_retail_price_form_customers_profit_margin );
            $( '.retail_price_of_product_service' ).text( this.s4_a_retail_price_of_product_service );
            
            // Vars used for updating fields following this loop...
            annual_overheads_form_total = this.s4_a_annual_overheads_form_total;
            personal_salary_form_total = this.s4_a_personal_salary_form_total;
            
            //console.log( 'YO this.s4_a_product_1: ' + this.s4_a_product_1 );
            
            if ( this.s4_a_product_1 != '' ) {
                var s4_a_product_1_arr = this.s4_a_product_1.split( ',' );
                $( '#product_price_point_slider_1_title a' ).text( s4_a_product_1_arr[0] );
                //$( '#product_price_point_slider_1' ).attr( 'data-product-value', s4_a_product_1_arr[1] );
                $( '#product_price_point_slider_1_input' ).val( s4_a_product_1_arr[1] );
                //$( '#product_price_point_slider_1' ).attr( 'data-product-volume', s4_a_product_1_arr[2] );
                $( '#product_volume_slider_1_input' ).val( s4_a_product_1_arr[2] );
                //var price_point_handle_position = 100 - s4_a_product_1_arr[1];
                var price_point_handle_position = calculatePosition( s4_a_product_1_arr[1], 1 );
                //console.log( s4_a_product_1_arr[0] + ' price_point_handle_position: ' + price_point_handle_position );
                $( '#product_price_point_slider_1 .slider-handle' ).css( 'left', price_point_handle_position );
                //$( '#product_price_point_slider_1 .slider-handle' ).css( 'left', price_point_handle_position+'%' );
                //$( '#product_price_point_slider_1 .slider-handle' ).css( { 'left': 'calc('+s4_a_product_1_arr[1]+'% - 16px)' } );
                
                //$( '#product_price_point_slider_1' ).foundation('_reflow');
                
                $( '#product_price_point_slider_1_wrapper' ).show();
                
                $( '#product_volume_slider_1_title a' ).text( s4_a_product_1_arr[0] );
                //$( '#product_volume_slider_1' ).attr( 'data-product-value', s4_a_product_1_arr[1] );
                //$( '#product_volume_slider_1' ).attr( 'data-product-volume', s4_a_product_1_arr[2] );
                var volume_handle_position = calculatePosition( s4_a_product_1_arr[2], 1 );
                //console.log( s4_a_product_1_arr[0] + ' volume_handle_position: ' + volume_handle_position );
                $( '#product_volume_slider_1 .slider-handle' ).css( 'left', volume_handle_position );
                $( '#product_volume_slider_1_wrapper' ).show();
                
                //$( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '130px' ); // 90px slider_wrapper + 40px
                $( '.price_point_slider' ).show();
            
                pvv_count = pvv_count + 1;
                
            } else {
                $( '#product_price_point_slider_1_wrapper' ).hide();
                $( '#product_volume_slider_1_wrapper' ).hide();
                
            }
            
            if ( this.s4_a_product_2 != '' ) {
                var s4_a_product_2_arr = this.s4_a_product_2.split( ',' );
                $( '#product_price_point_slider_2_title a' ).text( s4_a_product_2_arr[0] );
                //$( '#product_price_point_slider_2' ).attr( 'data-product-value', s4_a_product_2_arr[1] );
                $( '#product_price_point_slider_2_input' ).val( s4_a_product_2_arr[1] );
                //$( '#product_price_point_slider_2' ).attr( 'data-product-volume', s4_a_product_2_arr[2] );
                $( '#product_volume_slider_2_input' ).val( s4_a_product_2_arr[2] );
                var price_point_handle_position = calculatePosition( s4_a_product_2_arr[1], 2 );
                //console.log( s4_a_product_2_arr[0] + ' price_point_handle_position: ' + price_point_handle_position );
                $( '#product_price_point_slider_2 .slider-handle' ).css( 'left', price_point_handle_position );
                $( '#product_price_point_slider_2_wrapper' ).show();
                
                $( '#product_volume_slider_2_title a' ).text( s4_a_product_2_arr[0] );
                //$( '#product_volume_slider_2' ).attr( 'data-product-value', s4_a_product_2_arr[1] );
                //$( '#product_volume_slider_2' ).attr( 'data-product-volume', s4_a_product_2_arr[2] );
                var volume_handle_position = calculatePosition( s4_a_product_2_arr[2], 2 );
                //console.log( s4_a_product_2_arr[0] + ' volume_handle_position: ' + volume_handle_position );
                $( '#product_volume_slider_2 .slider-handle' ).css( 'left', volume_handle_position );
                $( '#product_volume_slider_2_wrapper' ).show();
                
                //$( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '220px' ); // 180px slider_wrapper + 40px
                $( '.price_point_slider' ).show();
                
                pvv_count = pvv_count + 1;
                
            } else {
                $( '#product_price_point_slider_2_wrapper' ).hide();
                $( '#product_volume_slider_2_wrapper' ).hide();
            }
            
            if ( this.s4_a_product_3 != '' ) {
                var s4_a_product_3_arr = this.s4_a_product_3.split( ',' );
                $( '#product_price_point_slider_3_title a' ).text( s4_a_product_3_arr[0] );
                //$( '#product_price_point_slider_3' ).attr( 'data-product-value', s4_a_product_3_arr[1] );
                $( '#product_price_point_slider_3_input' ).val( s4_a_product_3_arr[1] );
                //$( '#product_price_point_slider_3' ).attr( 'data-product-volume', s4_a_product_3_arr[2] );
                $( '#product_volume_slider_3_input' ).val( s4_a_product_3_arr[2] );
                var price_point_handle_position = calculatePosition( s4_a_product_3_arr[1], 3 );
                //console.log( s4_a_product_3_arr[0] + ' price_point_handle_position: ' + price_point_handle_position );
                $( '#product_price_point_slider_3 .slider-handle' ).css( 'left', price_point_handle_position );
                $( '#product_price_point_slider_3_wrapper' ).show();
                
                $( '#product_volume_slider_3_title a' ).text( s4_a_product_3_arr[0] );
                //$( '#product_volume_slider_3' ).attr( 'data-product-value', s4_a_product_3_arr[1] );
                //$( '#product_volume_slider_3' ).attr( 'data-product-volume', s4_a_product_3_arr[2] );
                var volume_handle_position = calculatePosition( s4_a_product_3_arr[2], 3 );
                //console.log( s4_a_product_3_arr[0] + ' volume_handle_position: ' + volume_handle_position );
                $( '#product_volume_slider_3 .slider-handle' ).css( 'left', volume_handle_position );
                $( '#product_volume_slider_3_wrapper' ).show();
                
                //$( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '310px' ); // 270px slider_wrapper + 40px
                $( '.price_point_slider' ).show();
                
                pvv_count = pvv_count + 1;
 
            } else {
                $( '#product_price_point_slider_3_wrapper' ).hide();
                $( '#product_volume_slider_3_wrapper' ).hide();
            }
            
            if ( this.s4_a_product_4 != '' ) {
                var s4_a_product_4_arr = this.s4_a_product_4.split( ',' );
                $( '#product_price_point_slider_4_title a' ).text( s4_a_product_4_arr[0] );
                //$( '#product_price_point_slider_4' ).attr( 'data-product-value', s4_a_product_4_arr[1] );
                $( '#product_price_point_slider_4_input' ).val( s4_a_product_4_arr[1] );
                //$( '#product_price_point_slider_4' ).attr( 'data-product-volume', s4_a_product_4_arr[2] );
                $( '#product_volume_slider_4_input' ).val( s4_a_product_4_arr[2] );
                var price_point_handle_position = calculatePosition( s4_a_product_4_arr[1], 4 );
                //console.log( s4_a_product_4_arr[0] + ' price_point_handle_position: ' + price_point_handle_position );
                $( '#product_price_point_slider_4 .slider-handle' ).css( 'left', price_point_handle_position );
                $( '#product_price_point_slider_4_wrapper' ).show();
                
                $( '#product_volume_slider_4_title a' ).text( s4_a_product_4_arr[0] );
                //$( '#product_volume_slider_4' ).attr( 'data-product-value', s4_a_product_4_arr[1] );
                //$( '#product_volume_slider_4' ).attr( 'data-product-volume', s4_a_product_4_arr[2] );
                var volume_handle_position = calculatePosition( s4_a_product_4_arr[2], 4 );
                //console.log( s4_a_product_4_arr[0] + ' volume_handle_position: ' + volume_handle_position );
                $( '#product_volume_slider_4 .slider-handle' ).css( 'left', volume_handle_position );
                $( '#product_volume_slider_4_wrapper' ).show();
                
                //$( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '400px' ); // 360px slider_wrapper + 40px
                $( '.price_point_slider' ).show();
                
                pvv_count = pvv_count + 1;
     
            } else {
                $( '#product_price_point_slider_4_wrapper' ).hide();
                $( '#product_volume_slider_4_wrapper' ).hide();
            }
            
            if ( this.s4_a_product_5 != '' ) {
                var s4_a_product_5_arr = this.s4_a_product_5.split( ',' );
                $( '#product_price_point_slider_5_title a' ).text( s4_a_product_5_arr[0] );
                //$( '#product_price_point_slider_5' ).attr( 'data-product-value', s4_a_product_5_arr[1] );
                $( '#product_price_point_slider_5_input' ).val( s4_a_product_5_arr[1] );
                //$( '#product_price_point_slider_5' ).attr( 'data-product-volume', s4_a_product_5_arr[2] );
                $( '#product_volume_slider_5_input' ).val( s4_a_product_5_arr[2] );
                var price_point_handle_position = calculatePosition( s4_a_product_5_arr[1], 5 );
                //console.log( s4_a_product_5_arr[0] + ' price_point_handle_position: ' + price_point_handle_position );
                $( '#product_price_point_slider_5 .slider-handle' ).css( 'left', price_point_handle_position );
                $( '#product_price_point_slider_5_wrapper' ).show();
                
                $( '#product_volume_slider_5_title a' ).text( s4_a_product_5_arr[0] );
                //$( '#product_volume_slider_5' ).attr( 'data-product-value', s4_a_product_5_arr[1] );
                //$( '#product_volume_slider_5' ).attr( 'data-product-volume', s4_a_product_5_arr[2] );
                var volume_handle_position = calculatePosition( s4_a_product_5_arr[2], 5 );
                //console.log( s4_a_product_5_arr[0] + ' volume_handle_position: ' + volume_handle_position );
                $( '#product_volume_slider_5 .slider-handle' ).css( 'left', volume_handle_position );
                $( '#product_volume_slider_5_wrapper' ).show();
                
                //$( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '490px' ); // 450px slider_wrapper + 40px
                $( '.price_point_slider' ).show();
                                
                pvv_count = pvv_count + 1;

            } else {
                $( '#product_price_point_slider_5_wrapper' ).hide();
                $( '#product_volume_slider_5_wrapper' ).hide();
            }
            
            if ( this.s4_a_product_1 != '' && this.s4_a_product_2 != '' && this.s4_a_product_3 != '' && this.s4_a_product_4 != '' && this.s4_a_product_5 != '' ) { // If all 5 products are added then we hide the 'Add Product' button
                $( '.add_product_value_entry' ).hide();
                
            } else if ( this.s4_a_product_1 == '' && this.s4_a_product_2 == '' && this.s4_a_product_3 == '' && this.s4_a_product_4 == '' && this.s4_a_product_5 == '' ) { // If all products are empty then we hide the 'price_point_slider' container and show the 'Add Product' button
                $( '.price_point_slider' ).hide();
                $( '.add_product_value_entry' ).show();
                
            } else { // If at least one but less than 5 products have been added then we show the 'Add Product' button
                $( '.add_product_value_entry' ).show();
            }

            entry_count++;
            
        });
        console.log( 'rendering...' );
        
        // Update fields...
        this.updateBusinessOverheadsFields( annual_overheads_form_total );
        this.updateSalaryFields( personal_salary_form_total );
        
        if ( pvv_count > 0 ) {
            $( '.product_price_point_slider_next' ).removeClass( 'disabled' );
        } else {
            $( '.product_price_point_slider_next' ).addClass( 'disabled' );
        }
        
        // Set height of Left / Right labels based on pvv_count...
        if ( pvv_count == 1 ) {
            $( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '130px' ); // 90px slider_wrapper + 40px
        } else if ( pvv_count == 2 ) {
            $( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '220px' ); // 180px slider_wrapper + 40px
        } else if ( pvv_count == 3 ) {
            $( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '310px' ); // 270px slider_wrapper + 40px
        } else if ( pvv_count == 4 ) {
            $( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '400px' ); // 360px slider_wrapper + 40px
        } else if ( pvv_count == 5 ) {
            $( '.price_point_slider .left span, .price_point_slider .right span' ).css( 'width', '490px' ); // 450px slider_wrapper + 40px
        }
        
        this.product_value_entry_count = pvv_count;
        console.log( 'pvv_count: ' + pvv_count);
        console.log( 'this.product_value_entry_count: ' + this.product_value_entry_count);
        console.log( 'this.aon_section_4a_data[ 0 ][ \'s4_a_product_1\' ]: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_1' ] );
        console.log( 'this.aon_section_4a_data[ 0 ][ \'s4_a_product_2\' ]: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_2' ] );
        console.log( 'this.aon_section_4a_data[ 0 ][ \'s4_a_product_3\' ]: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_3' ] );
        console.log( 'this.aon_section_4a_data[ 0 ][ \'s4_a_product_4\' ]: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_4' ] );
        console.log( 'this.aon_section_4a_data[ 0 ][ \'s4_a_product_5\' ]: ' + this.aon_section_4a_data[ 0 ][ 's4_a_product_5' ] );
        
    },
    
    saveOverheads() {
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_rent_etc' ] = Number( $( '#s4_a_monthly_overheads_form_rent_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_property_etc' ] = Number( $( '#s4_a_monthly_overheads_form_property_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_phone_etc' ] = Number( $( '#s4_a_monthly_overheads_form_phone_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_bank_etc' ] = Number( $( '#s4_a_monthly_overheads_form_bank_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_car_etc' ] = Number( $( '#s4_a_monthly_overheads_form_car_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_accountancy_etc' ] = Number( $( '#s4_a_monthly_overheads_form_accountancy_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_wages_etc' ] = Number( $( '#s4_a_monthly_overheads_form_wages_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_other' ] = Number( $( '#s4_a_monthly_overheads_form_other' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_total' ] = Number( $( '#s4_a_monthly_overheads_form_total' ).text() );

        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_rent_etc' ] = Number( $( '#s4_a_annual_overheads_form_rent_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_property_etc' ] = Number( $( '#s4_a_annual_overheads_form_property_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_phone_etc' ] = Number( $( '#s4_a_annual_overheads_form_phone_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_bank_etc' ] = Number( $( '#s4_a_annual_overheads_form_bank_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_car_etc' ] = Number( $( '#s4_a_annual_overheads_form_car_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_accountancy_etc' ] = Number( $( '#s4_a_annual_overheads_form_accountancy_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_wages_etc' ] = Number( $( '#s4_a_annual_overheads_form_wages_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_other' ] = Number( $( '#s4_a_annual_overheads_form_other' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_total' ] = Number( $( '#s4_a_annual_overheads_form_total' ).text() );
  
        console.log( 'SAVE OVERHEADS' );
        console.table( this.aon_section_4a_data );
    },

    saveSalary() {
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_rent_etc' ] = Number( $( '#s4_a_personal_salary_form_rent_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_council_tax_etc' ] = Number( $( '#s4_a_personal_salary_form_council_tax_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_telephone_internet' ] = Number( $( '#s4_a_personal_salary_form_telephone_internet' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_debts_etc' ] = Number( $( '#s4_a_personal_salary_form_debts_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_food_etc' ] = Number( $( '#s4_a_personal_salary_form_food_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_events_etc' ] = Number( $( '#s4_a_personal_salary_form_events_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_insurance_etc' ] = Number( $( '#s4_a_personal_salary_form_insurance_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_tax_etc' ] = Number( $( '#s4_a_personal_salary_form_tax_etc' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_national_insurance' ] = Number( $( '#s4_a_personal_salary_form_national_insurance' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_total' ] = Number( $( '#s4_a_personal_salary_form_total' ).text() );
        
        this.aon_section_4a_data[ 0 ][ 's4_a_monthly_costs_total' ] = Number( $( '.monthly_costs_total' ).text() );
        this.aon_section_4a_data[ 0 ][ 's4_a_weekly_costs_total' ] = Number( $( '.weekly_costs_total' ).text() );
        this.aon_section_4a_data[ 0 ][ 's4_a_daily_costs_total' ] = Number( $( '.daily_costs_total' ).text() );
        
        console.log( 'SAVE PERSONAL SALARY' );
        console.table( this.aon_section_4a_data );
    },

    saveCostPrice() {
        this.aon_section_4a_data[ 0 ][ 's4_a_cost_price_form_time_to_make' ] = Number( $( '#s4_a_cost_price_form_time_to_make' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_cost_price_form_materials_production' ] = Number( $( '#s4_a_cost_price_form_materials_production' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_cost_of_product_or_service' ] = Number( parseFloat( $( '.cost_of_product_or_service' ).text() ).toFixed( 2 ) );
        console.log( 'SAVE SELLING PRICE' );
        console.table( this.aon_section_4a_data );
    },

    saveSellingPrice() {
        this.aon_section_4a_data[ 0 ][ 's4_a_selling_price_form_profit_margin' ] = Number( $( '#s4_a_selling_price_form_profit_margin' ).val() );
        //this.aon_section_4a_data[ 0 ][ 's4_a_selling_price_of_product_service' ] = Number( $( '#s4_a_selling_price_of_product_service' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_selling_price_of_product_service' ] = Number( parseFloat( $( '.selling_price_of_product_service' ).text() ).toFixed( 2 ) );
        //this.aon_section_4a_data[ 0 ][ 's4_a_cost_of_product_or_service' ] = Number( $( '.selling_price_of_product_service' ).text() );
        console.log( 'SAVE SELLING PRICE' );
        console.table( this.aon_section_4a_data );
    },

    saveRetailPrice() {
        this.aon_section_4a_data[ 0 ][ 's4_a_retail_price_form_customers_profit_margin' ] = Number( $( '#s4_a_retail_price_form_customers_profit_margin' ).val() );
        this.aon_section_4a_data[ 0 ][ 's4_a_retail_price_of_product_service' ] = Number( $( '.retail_price_of_product_service' ).text() );
        console.log( 'SAVE SELLING PRICE' );
        console.table( this.aon_section_4a_data );
    },

    saveProduct( num ) {
        //this.aon_section_4a_data[ 0 ][ 's4_a_product_' + num ] = product_ref_here;
        console.log( 'SAVE PRODUCT: ' + num );
        console.table( this.aon_section_4a_data );
    },

    
    addDataEntry() {
        // Default variables for data structure...
        var s4_a_annual_overheads_form_rent_etc = 0;
        var s4_a_annual_overheads_form_property_etc = 0;
        var s4_a_annual_overheads_form_phone_etc = 0;
        var s4_a_annual_overheads_form_bank_etc = 0;
        var s4_a_annual_overheads_form_car_etc = 0;
        var s4_a_annual_overheads_form_accountancy_etc = 0;
        var s4_a_annual_overheads_form_wages_etc = 0;
        var s4_a_annual_overheads_form_other = 0;
        var s4_a_annual_overheads_form_total = 0;
      
        var s4_a_monthly_overheads_form_rent_etc = 0;
        var s4_a_monthly_overheads_form_property_etc = 0;
        var s4_a_monthly_overheads_form_phone_etc = 0;
        var s4_a_monthly_overheads_form_bank_etc = 0;
        var s4_a_monthly_overheads_form_car_etc = 0;
        var s4_a_monthly_overheads_form_accountancy_etc = 0;
        var s4_a_monthly_overheads_form_wages_etc = 0;
        var s4_a_monthly_overheads_form_other = 0;
        var s4_a_monthly_overheads_form_total = 0;
      
        var s4_a_personal_salary_form_rent_etc = 0;
        var s4_a_personal_salary_form_council_tax_etc = 0;
        var s4_a_personal_salary_form_telephone_internet = 0;
        var s4_a_personal_salary_form_debts_etc = 0;
        var s4_a_personal_salary_form_food_etc = 0;
        var s4_a_personal_salary_form_events_etc = 0;
        var s4_a_personal_salary_form_insurance_etc = 0;
        var s4_a_personal_salary_form_tax_etc = 0;
        var s4_a_personal_salary_form_national_insurance = 0;
        var s4_a_personal_salary_form_total = 0;
        
        var s4_a_monthly_costs_total = 0;
        var s4_a_weekly_costs_total = 0;
        var s4_a_daily_costs_total = 0;
        
        var s4_a_cost_price_form_time_to_make = 0;
        var s4_a_cost_price_form_materials_production = 0;
        var s4_a_cost_of_product_or_service = 0;
        
        var s4_a_selling_price_form_profit_margin = 0;
        var s4_a_selling_price_of_product_service = 0;
        
        var s4_a_retail_price_form_customers_profit_margin = 0;
        var s4_a_retail_price_of_product_service = 0;
        
        var s4_a_product_1 = '';
        var s4_a_product_2 = '';
        var s4_a_product_3 = '';
        var s4_a_product_4 = '';
        var s4_a_product_5 = '';
        
        // Push default data to data structure array...
        this.aon_section_4a_data.push( { 
            s4_a_annual_overheads_form_rent_etc,
            s4_a_annual_overheads_form_property_etc,
            s4_a_annual_overheads_form_phone_etc,
            s4_a_annual_overheads_form_bank_etc,
            s4_a_annual_overheads_form_car_etc,
            s4_a_annual_overheads_form_accountancy_etc,
            s4_a_annual_overheads_form_wages_etc,
            s4_a_annual_overheads_form_other,
            s4_a_annual_overheads_form_total,

            s4_a_monthly_overheads_form_rent_etc,
            s4_a_monthly_overheads_form_property_etc,
            s4_a_monthly_overheads_form_phone_etc,
            s4_a_monthly_overheads_form_bank_etc,
            s4_a_monthly_overheads_form_car_etc,
            s4_a_monthly_overheads_form_accountancy_etc,
            s4_a_monthly_overheads_form_wages_etc,
            s4_a_monthly_overheads_form_other,
            s4_a_monthly_overheads_form_total,

            s4_a_personal_salary_form_rent_etc,
            s4_a_personal_salary_form_council_tax_etc,
            s4_a_personal_salary_form_telephone_internet,
            s4_a_personal_salary_form_debts_etc,
            s4_a_personal_salary_form_food_etc,
            s4_a_personal_salary_form_events_etc,
            s4_a_personal_salary_form_insurance_etc,
            s4_a_personal_salary_form_tax_etc,
            s4_a_personal_salary_form_national_insurance,
            s4_a_personal_salary_form_total,
            
            s4_a_monthly_costs_total,
            s4_a_weekly_costs_total,
            s4_a_daily_costs_total,
            s4_a_cost_price_form_time_to_make,
            s4_a_cost_price_form_materials_production,
            s4_a_cost_of_product_or_service,
            s4_a_selling_price_form_profit_margin,
            s4_a_selling_price_of_product_service,
            s4_a_retail_price_form_customers_profit_margin,
            s4_a_retail_price_of_product_service,
            
            s4_a_product_1,
            s4_a_product_2,
            s4_a_product_3,
            s4_a_product_4,
            s4_a_product_5
            
        } );
        
        console.table( 'addDataEntry: ' + this.aon_section_4a_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_4a_data_json = $( '#section_4a_data_json' ).val();
            this.aon_section_4a_data = JSON.parse( aon_section_4a_data_json );
            //$( '.weekly_hours_making_work' ).val( this.aon_section_4a_data[ 0 ][ 'weekly_hours_making_work' ] );
            $( '#s4_a_annual_overheads_form_rent_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_rent_etc' ] );
            $( '#s4_a_annual_overheads_form_property_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_property_etc' ] );
            $( '#s4_a_annual_overheads_form_phone_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_phone_etc' ] );
            $( '#s4_a_annual_overheads_form_bank_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_bank_etc' ] );
            $( '#s4_a_annual_overheads_form_car_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_car_etc' ] );
            $( '#s4_a_annual_overheads_form_accountancy_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_accountancy_etc' ] );
            $( '#s4_a_annual_overheads_form_wages_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_wages_etc' ] );
            $( '#s4_a_annual_overheads_form_other' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_other' ] );
            $( '#s4_a_annual_overheads_form_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_annual_overheads_form_total' ] );

            $( '#s4_a_monthly_overheads_form_rent_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_rent_etc' ] );
            $( '#s4_a_monthly_overheads_form_property_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_property_etc' ] );
            $( '#s4_a_monthly_overheads_form_phone_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_phone_etc' ] );
            $( '#s4_a_monthly_overheads_form_bank_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_bank_etc' ] );
            $( '#s4_a_monthly_overheads_form_car_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_car_etc' ] );
            $( '#s4_a_monthly_overheads_form_accountancy_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_accountancy_etc' ] );
            $( '#s4_a_monthly_overheads_form_wages_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_wages_etc' ] );
            $( '#s4_a_monthly_overheads_form_other' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_other' ] );
            $( '#s4_a_monthly_overheads_form_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_overheads_form_total' ] );

            $( '#s4_a_personal_salary_form_rent_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_rent_etc' ] );
            $( '#s4_a_personal_salary_form_council_tax_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_council_tax_etc' ] );
            $( '#s4_a_personal_salary_form_telephone_internet' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_telephone_internet' ] );
            $( '#s4_a_personal_salary_form_debts_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_debts_etc' ] );
            $( '#s4_a_personal_salary_form_food_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_food_etc' ] );
            $( '#s4_a_personal_salary_form_events_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_events_etc' ] );
            $( '#s4_a_personal_salary_form_insurance_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_insurance_etc' ] );
            $( '#s4_a_personal_salary_form_tax_etc' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_tax_etc' ] );
            $( '#s4_a_personal_salary_form_national_insurance' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_national_insurance' ] );
            $( '#s4_a_personal_salary_form_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_personal_salary_form_total' ] );
            
            $( '#s4_a_monthly_costs_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_monthly_costs_total' ] );
            $( '#s4_a_weekly_costs_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_weekly_costs_total' ] );
            $( '#s4_a_daily_costs_total' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_daily_costs_total' ] );
            $( '#s4_a_cost_price_form_time_to_make' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_cost_price_form_time_to_make' ] );
            $( '#s4_a_cost_price_form_materials_production' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_cost_price_form_materials_production' ] );
            $( '#s4_a_cost_of_product_or_service' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_cost_of_product_or_service' ] );
            $( '#s4_a_selling_price_form_profit_margin' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_selling_price_form_profit_margin' ] );
            $( '#s4_a_selling_price_of_product_service' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_selling_price_of_product_service' ] );
            $( '#s4_a_retail_price_form_customers_profit_margin' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_retail_price_form_customers_profit_margin' ] );
            $( '#s4_a_retail_price_of_product_service' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_retail_price_of_product_service' ] );
            
            $( '#s4_a_product_1' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_product_1' ] );
            $( '#s4_a_product_2' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_product_2' ] );
            $( '#s4_a_product_3' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_product_3' ] );
            $( '#s4_a_product_4' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_product_4' ] );
            $( '#s4_a_product_5' ).val( this.aon_section_4a_data[ 0 ][ 's4_a_product_5' ] );
            
            if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
                $( '#s4_a_personal_salary_form input ').attr( 'readonly', true );
                $( '#s4_a_personal_salary_form').addClass( 'readonly' );
                $( '#s4_a_personal_salary_form input ').addClass( 'readonly' );
            }

            
        } else if ( mode == 'load_demo' ) {
            
            // Using temp JSON source for now, but this would load from the backend...
            var aon_section_4a_data_json = '[';
            
                aon_section_4a_data_json += '{';

                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_rent_etc":1000,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_property_etc":200,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_phone_etc":90,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_bank_etc":40,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_car_etc":300,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_accountancy_etc":100,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_wages_etc":2500,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_other":750,';
                aon_section_4a_data_json += '"s4_a_monthly_overheads_form_total":4980,';

                aon_section_4a_data_json += '"s4_a_annual_overheads_form_rent_etc":12000,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_property_etc":2400,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_phone_etc":1080,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_bank_etc":480,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_car_etc":3600,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_accountancy_etc":1200,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_wages_etc":30000,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_other":9000,';
                aon_section_4a_data_json += '"s4_a_annual_overheads_form_total":59760,';
            
                aon_section_4a_data_json += '"s4_a_personal_salary_form_rent_etc":190,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_council_tax_etc":200,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_telephone_internet":210,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_debts_etc":220,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_food_etc":230,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_events_etc":240,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_insurance_etc":250,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_tax_etc":260,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_national_insurance":270,';
                aon_section_4a_data_json += '"s4_a_personal_salary_form_total":2070,';
            
                aon_section_4a_data_json += '"s4_a_annual_business_overheads_total":2272.50,';
                aon_section_4a_data_json += '"s4_a_monthly_costs_total":2272.50,';
                aon_section_4a_data_json += '"s4_a_weekly_costs_total":524.42,';
                aon_section_4a_data_json += '"s4_a_daily_costs_total":104.88,';
                aon_section_4a_data_json += '"s4_a_cost_price_form_time_to_make":3,';
                aon_section_4a_data_json += '"s4_a_cost_price_form_materials_production":56,';
                aon_section_4a_data_json += '"s4_a_cost_of_product_or_service":370.64,';
                aon_section_4a_data_json += '"s4_a_selling_price_form_profit_margin":10,';
                aon_section_4a_data_json += '"s4_a_selling_price_of_product_service":407.70,';
                aon_section_4a_data_json += '"s4_a_retail_price_form_customers_profit_margin":20,';
                aon_section_4a_data_json += '"s4_a_retail_price_of_product_service":489.24,';
            
                aon_section_4a_data_json += '"s4_a_product_1":"Disco Cheese,100,10",';
                aon_section_4a_data_json += '"s4_a_product_2":"Glow-in-the-dark oven gloves that let you cook in the dark,80,30",';
                aon_section_4a_data_json += '"s4_a_product_3":"Invisible toothpaste,55,100",';
                aon_section_4a_data_json += '"s4_a_product_4":"Potato boxes,0,70",';
                aon_section_4a_data_json += '"s4_a_product_5":""';
                //aon_section_4a_data_json += '"s4_a_product_5":"Snowangel cakes,5,50"';

                aon_section_4a_data_json += '}';
                
                aon_section_4a_data_json += ']';

            this.aon_section_4a_data = JSON.parse( aon_section_4a_data_json );

        } else if ( mode == 'start' ) {

            this.addDataEntry();
            
        }
        console.table( this.aon_section_4a_data );
        console.log( 'this.aon_section_4a_data[0][\'s4_a_annual_overheads_form_total\']: ' + this.aon_section_4a_data[0]['s4_a_annual_overheads_form_total'] );
  
    },
    
    /*loadSavedData() {
        this.loadData( 'load' );  
    },*/
        
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_section_4a_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '4A AJAX - START' );
        var meta = { 'section_4a_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '4A AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_4a_data );
    },
    
    resetProcess() {
        // Reset fields, enable / disable UI elements etc...
    }

}